import UtilityService from './UtilityService';
import StorageService from './StorageService';
import jwt_decode from 'jwt-decode';
import appConfig from '../config.json';

export default {
  getJWTFromStorage: async (storageType: string) => {
    const lu = StorageService.getItem(storageType, 'access_token');

    return lu;
  },
  getApiHeader: async (storageType: string, isJsonBody: boolean) => {
    const jwt = StorageService.getItem(storageType, 'access_token');
    const ct = isJsonBody ? 'application/json; charset=UTF-8' : 'multipart/form-data; charset=UTF-8';
    if (!UtilityService.isNullOrEmpty(jwt))
      return {
        'Content-Type': ct,
        Origin: appConfig.Orgin,
        // 'Access-Control-Allow-Origin': '*',
        //   'Access-Control-Allow-Credentials': true,
        'Accept-Language': 'fa-IR',
        // Authorization: 'Bearer ' + jwt,
        // ApiKey: apiKey,
      };

    return {
      'Content-Type': ct,
      'Accept-Language': 'fa-IR',
      Origin: appConfig.Orgin,
      // 'Access-Control-Allow-Origin': '*',
      //'Access-Control-Allow-Credentials': true,
      //  ApiKey: apiKey,
    };
  },
  isAuthenticated: async (storageType: string) => {
    const jwt = StorageService.getItem(storageType, 'access_token');
    if (!UtilityService.isNullOrEmpty(jwt)) return true;
    return false;
  },
  getNameIdentifier: async (storageType: string) => {
    const jwt = StorageService.getItem(storageType, 'access_token');
    const decodedToken = jwt_decode(jwt as string) as any;
    const nid = decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'];
    if (!UtilityService.isNullOrEmpty(nid)) return Number(nid);
    return 0;
  },
  getUserName: (storageType: string) => {
    const jwt = StorageService.getItem(storageType, 'access_token');
    const decodedToken = jwt_decode(jwt as string) as any;
    const nid = decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname'];
    if (!UtilityService.isNullOrEmpty(nid)) return nid;
    return '';
  },
  getSurname: (storageType: string) => {
    const jwt = StorageService.getItem(storageType, 'access_token');
    const decodedToken = jwt_decode(jwt as string) as any;
    const nid = decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname'];
    if (!UtilityService.isNullOrEmpty(nid)) return nid;
    return '';
  },
  getFullName: (storageType: string) => {
    const jwt = StorageService.getItem(storageType, 'access_token');
    const decodedToken = jwt_decode(jwt as string) as any;
    const fn = decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname'];
    const ln = decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/surname'];
    if (!UtilityService.isNullOrEmpty(fn) || !UtilityService.isNullOrEmpty(ln)) return fn + ' ' + ln;
    return '';
  },
};
